import { useMemo } from 'react';
import { CANVAS_LEFT_MARGIN } from '@constants/canvas/general';
import useCanvasWidth from '@hooks/canvas/useCanvasWidth';
import { useAppSelector } from '@hooks/store';

import {
  getExtentBottomBound,
  getExtentRightBound,
} from './translateExtent.helpers';

const useTranslateExtent = () => {
  const { canvasWidth, containerHeight } = useCanvasWidth();

  const rightBound = useAppSelector((state) =>
    getExtentRightBound(canvasWidth, state.ui.canvasZoom),
  );

  const bottomBound = useAppSelector((state) =>
    getExtentBottomBound(
      state.ui.canvasHeight,
      containerHeight,
      state.ui.canvasZoom,
    ),
  );

  return useMemo<[[number, number], [number, number]]>(
    () => [
      [-CANVAS_LEFT_MARGIN, 0],
      [rightBound, bottomBound],
    ],
    [rightBound, bottomBound],
  );
};

export default useTranslateExtent;
